import { getToken } from "./authService";
import axios from "axios";
import { API_URL } from "./variables";

const upload_url = `${API_URL}/upload`;
const uploadImage = async (imageFile) => {
  const formData = new FormData();
  formData.append("image", imageFile);

  try {
    const token = getToken();
    const response = await axios.post(upload_url, formData, {
      headers: {
        Authorization: `${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data.file_name;
  } catch (err) {
    throw new Error("Image upload failed");
  }
};
function $uploads(image) {
  return `https://songstarktours.s3.ap-northeast-2.amazonaws.com/${image}`;
}
function $imageError() {
  return "https://placehold.co/150";
}
export { uploadImage, $uploads, $imageError };
